var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "columns is-gapless" }, [
    _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label is-required-label" }, [
          _vm._v("Job Stage "),
        ]),
        _c("div", { staticClass: "control is-extended" }, [
          _c("div", { staticClass: "select is-fullwidth" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value.jobStage,
                    expression: "value.jobStage",
                  },
                ],
                class: { "input is-danger": _vm.$v.entity.jobStage.$error },
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.value,
                        "jobStage",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.jobStageOnChange,
                  ],
                },
              },
              _vm._l(_vm.jobStages, function (s, index) {
                return _c(
                  "option",
                  { key: index, domProps: { value: s.stage } },
                  [_vm._v(" " + _vm._s(s.description) + " ")]
                )
              }),
              0
            ),
          ]),
          _vm.$v.entity && !_vm.$v.entity.jobStage.required
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v("Job Stage is required"),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label is-required-label" }, [
          _vm._v("Sub Job Stage "),
        ]),
        _c("div", { staticClass: "control is-extended" }, [
          _c("div", { staticClass: "select is-fullwidth" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value.subJobStageId,
                    expression: "value.subJobStageId",
                  },
                ],
                class: { "input is-danger": _vm.$v.entity.jobStage.$error },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.value,
                      "subJobStageId",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              _vm._l(_vm.subJobStages, function (s, index) {
                return _c(
                  "option",
                  { key: index, domProps: { value: s.subJobStageId } },
                  [_vm._v(" " + _vm._s(s.subJobStageName) + " ")]
                )
              }),
              0
            ),
          ]),
          _vm.$v.entity && !_vm.$v.entity.subJobStageId.required
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v("Sub Job Stage is required"),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "buttons has-addons is-centered" }, [
        _c(
          "span",
          {
            staticClass: "button",
            class: { "is-success is-selected": _vm.value.isActive },
            on: {
              click: function ($event) {
                return _vm.toggleActive(true)
              },
            },
          },
          [_vm._m(0), _c("span", [_vm._v("Active")])]
        ),
        _c(
          "span",
          {
            staticClass: "button",
            class: { "is-danger is-selected": !_vm.value.isActive },
            on: {
              click: function ($event) {
                return _vm.toggleActive(false)
              },
            },
          },
          [_vm._m(1), _c("span", [_vm._v("In-Active")])]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }